

<template>
  <div class="mt-10 sm:mt-20">
    <div data-aos="fade-up" data-aos-duration="1200" class="text-center">
      <p
        class="font-general-semibold text-2xl sm:text-4xl font-semibold mb-2 text-ternary-dark dark:text-ternary-light"
      >{{ clientsHeading }}</p>
    </div>
    <div
      data-aos="fade-up"
      data-aos-duration="1500"
      class="grid grid-cols-3 sm:grid-cols-6 mt-10 sm:mt-14 gap-2 text-center"
    >
      <TeckStackSingle v-for="client in clients" :key="client.id" :client="client" />
    </div>
  </div>
</template>
<script>
import TeckStackSingle from "./TeckStackSingle.vue";

export default {
  components: {
    TeckStackSingle
  },
  data: () => {
    return {
      clientsHeading: "MY TECH STACK",
      clients: [
        {
          id: 1,
          title: "HTML",
          img: require("@/assets/images/stacks/html.png")
        },
        {
          id: 2,
          title: "CSS",
          img: require("@/assets/images/stacks/css.png")
        },
        {
          id: 3,
          title: "PHP",
          img: require("@/assets/images/stacks/php.png")
        },
        {
          id: 4,
          title: "JAVASCRIPT",
          img: require("@/assets/images/stacks/javascript.png")
        },
        {
          id: 13,
          title: ".NET",
          img: require("@/assets/images/stacks/net.png")
        },
        {
          id: 6,
          title: "C#",
          img: require("@/assets/images/stacks/c-sharp.png")
        },

        {
          id: 7,
          title: "MYSQL",
          img: require("@/assets/images/stacks/mysql.png")
        },
        {
          id: 8,
          title: "VUE",
          img: require("@/assets/images/stacks/vue.png")
        },
        {
          id: 9,
          title: "LARAVEL",
          img: require("@/assets/images/stacks/laravel.png")
        },
        {
          id: 10,
          title: "VUETIFY",
          img: require("@/assets/images/stacks/vuetify.png")
        },
        {
          id: 12,
          title: "TAILWIND",
          img: require("@/assets/images/stacks/tailwind.png")
        },
        {
          id: 14,
          title: "GIT",
          img: require("@/assets/images/stacks/Git.png")
        },
        {
          id: 15,
          title: "DOCKER",
          img: require("@/assets/images/stacks/docker.png")
        },
        {
          id: 16,
          title: "UBUNTU",
          img: require("@/assets/images/stacks/ubuntu.png")
        },
        {
          id: 17,
          title: "DIGITAL OCEAN",
          img: require("@/assets/images/stacks/docean.png")
        },
        {
          id: 17,
          title: "APACHE",
          img: require("@/assets/images/stacks/apache.png")
        },
        {
          id: 18,
          title: "IONIC",
          img: require("@/assets/images/stacks/ionic.png")
        }
      ]
    };
  }
};
</script>